import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {IntIconModule} from "../../int-icon";
import {IntClearActionDefaultComponent} from "./int-clear-action-default.component";

@NgModule({
  imports: [
    CommonModule,
    IntIconModule
  ],
  declarations: [
    IntClearActionDefaultComponent
  ],
  exports: [
    IntClearActionDefaultComponent
  ]
})
export class IntClearActionDefaultModule {}
